import React from 'react';

import i18n from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';

import en from "@/translations/en.json";
import gsw from "@/translations/gsw.json";

import Dropdown, { FieldInfo } from '@/components/Common/Dropdown';

export const LANGUAGES: FieldInfo[] = [
  { value: 'en', desc: 'English' },
  { value: 'gsw', desc: 'Schweizerdeutsch' },
];

const RESOURCES = {
  en: en,
  gsw: gsw,
};


var translationInitialized = false;

export function initTranslation() {
	if (translationInitialized)
		return;
	
	const LANGUAGE_DETECTOR = {
		type: 'languageDetector',
		async: true,
		detect: (callback: any) => {
			const language = localStorage.getItem('user-language');
			
			if (!language) {
				console.log('No language is set, choosing English as fallback');
				callback('en');
				return;
			}
			callback(language);
		},
		init: () => {},
		cacheUserLanguage: (language: string) => {
			localStorage.setItem('user-language', language);
			console.log("initTranslation/Setting user-language to '" + language + "'");
		},
	};
	
	const i18any = i18n as any;
	
	i18any
	// detect language
	.use(LANGUAGE_DETECTOR)
	// pass the i18n instance to react-i18next.
	.use(initReactI18next)
	// set options
	.init({
		resources: RESOURCES,
		// Load-bearing, not cosmetic: gsw.json only translates a handful of
		// namespaces, so without a fallback a Swiss-German admin sees literal
		// key strings ("epg:sources:url") for every untranslated page.
		fallbackLng: 'en',
		react: {
			useSuspense: false
		},
		interpolation: {
			escapeValue: false
		}
	});
	
	translationInitialized = true;
}

export const LanguageDropDown = () => {
	const { i18n } = useTranslation();
	const [language, setLanguage] = React.useState(i18n.language);
	
	console.log("LanguageDropDown/language=" + language);
	
	const changeLanguage = (lang: string) => {
		setLanguage(lang);
		console.log("LanguageDropDown/changeLanguage/lang=" + lang);
		i18n.changeLanguage(lang);
	};

	//console.log("LanguageDropDown/language=" + language + "/i18n.language=" + i18n.language);

	return (
	  <Dropdown variant="flat"
	            value={language}
				className="min-w-[180px] h-[36px] mr-[10px] flex-00"
				setValue={(val) => changeLanguage(val as string)}
				options={LANGUAGES}>
	    <>
	    </>
	  </Dropdown>
	);
};

/*
export const LanguageBar = (props: FlexRowProps) => {
	const { i18n } = useTranslation();
	
	const changeLanguage = (lang: string) => {
		i18n.changeLanguage(lang);
	};

	return (
	<FlexRow width="auto"
	         sx={{
	           alignItems: "center",
	           justifyContent: "center",
	         }}
	         {...props}>
	{	LANGUAGES.map(
			(lang, i) =>
	  <Typography variant="r16"
		          color="#7B7B7B"
		          onClick={() => changeLanguage(lang.value)}
		          key={lang.value}
		          sx={{
		            paddingLeft: (i > 0 ? '15px' : '0'),
		            borderRight: (i + 1 < LANGUAGES.length ? '1px solid #7B7B7B' : 'none'),
		            paddingRight: '15px',
		            cursor: 'pointer',
		          }}>
	    { lang.desc }
	  </Typography>
    )}
	</FlexRow>
	);
};
*/


